import React, { Component, Fragment } from "react";
import { connect } from "react-redux";
import { CONFIG, CONFIG_API_BE, URL_AKM } from "../../../../../config";
import { cekCookies } from "../../../../../actions";
import __, { isEmpty } from "lodash";
import LoaderModal from "../../../../modal/LoaderModal";
import Navbar from "../../../navbar/Navbar";
import Sidebar from "../../../sidebar/Sidebar";
import accountManagement from "../../../../../apis/accountManagement";
import eduprimeApi from "../../../../../apis/eduprimeApi";
import akmApi from "../../../../../apis/akmApi";

import ReactExport from "react-data-export";
import Select from "react-select";
import { Row, Col, Alert, Modal, Tabs, Tab, Button, Card } from "react-bootstrap";
import { Accordion, AccordionDetails, AccordionSummary, Checkbox, TextField, Typography } from "@material-ui/core";

class Voucher extends Component {
    constructor(props) {
        super(props);
        this.state = {
            error: null,
            resMessage: "",
            alertShow: false,
            isFetching: false,
            listProvinsi: [],
            listKabKota: [],
            listSekolah: [],
            listSekolahArray: [],
            listPaketProgram: [],
            listPenjualanArray: [],
            listPenjualan: [],
            sisaVoucher: "",
            voucherTerpakai: "",
            listVoucherSekolah: [],
            jumVoucherSekolah: "",
            jumNewVoucherSekolah: "0",
            objectSekolah: {},
            setUsername: "",
            searchUsername: {},
            searchBySchool: {},
            dataCheckboxSiswa: [],
            dataCheckboxKelasPararel: [],
            dataCheckboxKelas: [],
            isChecked: false,
            idPaketProgram: "",
            idSekolah: "",
            kodeJenisVoucher: "",
            idPenjualanVoucher: "",
            keterangan: "",
        };
    }

    async componentDidMount() {
        this.setState({
            isFetching: true,
        });
        await this.props.cekCookies();
        if (!__.isEmpty(this.props.account)) {
            this.fetchProvinsi();
            this.fetchPaketProgram();
        }
    }

    fetchProvinsi = async () => {
        this.setState({ isFetching: true });
        const respons = await eduprimeApi.get(CONFIG_API_BE.API_GET_PROVINSI, {});
        if (respons) {
            if (!__.isEmpty(respons.data.list_provinsi)) {
                const dataProvinsi = { value: "", label: "Pilih Provinsi...", id: "idProvinsi", selected: "selected" };
                this.state.listProvinsi.push(dataProvinsi);
                respons.data.list_provinsi.map((val, i) => {
                    const dataProvinsi = { value: val.ID_PROVINSI, label: val.NAMA_PROVINSI, id: "idProvinsi" };
                    this.state.listProvinsi.push(dataProvinsi);
                });
            }
        }
        this.setState({ isFetching: false });
    };

    fetchPaketProgram = async () => {
        this.setState({ isFetching: true });
        const response = await akmApi.get(URL_AKM.FETCH_PAKET_PROGRAM_AKTIF);
        if (response) {
            if (response.data.errorSchema.errorCode === URL_AKM.SUCCESS_ERROR_CODE) {
                const data = { value: "", label: "Pilih Paket Program...", id: "idPaketProgram", selected: "selected" };
                this.state.listPaketProgram.push(data);
                response.data.data.map((val, i) => {
                    const data = { value: val.idPaketProgram, label: val.namaProgram, id: "idPaketProgram" };
                    this.state.listPaketProgram.push(data);
                });
            }
        }
        this.setState({ isFetching: false });
    };

    handleChangeSelect = async (e) => {
        const name = e.id;
        const id = e.value;
        this.setState({
            [e.id]: id,
            isFetching: true,
        });

        if (name === "idProvinsi") {
            this.setState({
                objectSekolah: {},
                listKabKota: [],
                listSekolah: [],
                kodeJenjangSekolah: null,
            });
            const respons = await eduprimeApi.get(CONFIG_API_BE.API_GET_KAB_KOTA + id, {});
            if (respons) {
                if (!__.isEmpty(respons.data.list_kab_kota)) {
                    const data = { value: "", label: "Pilih Kota...", id: "idKabKota", selected: "selected" };
                    this.state.listKabKota.push(data);
                    respons.data.list_kab_kota.map((val, i) => {
                        const data = { value: val.ID_KABUPATEN_KOTA, label: val.NAMA_KABUPATEN_KOTA, id: "idKabKota" };
                        this.state.listKabKota.push(data);
                    });
                }
            }
        }

        if (name === "idKabKota") {
            this.setState({
                objectSekolah: {},
                listSekolah: [],
            });

            const response = await akmApi.get(URL_AKM.FETCH_SEKOLAH_BY_ID_KAB + id).catch(function (error) {
                this.setState({ error });
            });

            if (response.data.errorSchema.errorCode === URL_AKM.SUCCESS_ERROR_CODE) {
                this.setState({ listSekolahArray: response.data.data });
                const data = { value: "", label: "Pilih Sekolah...", id: "idSekolah", selected: "selected" };
                this.state.listSekolah.push(data);
                response.data.data.map((val, i) => {
                    const data = { value: val.idSekolah, label: val.namaSekolah, id: "idSekolah" };
                    this.state.listSekolah.push(data);
                });
            }
        }

        if (name === "idPaketProgram") {
            this.setState({
                objectSekolah: {},
                listPenjualan: [],
                sisaVoucher: "",
                voucherTerpakai: "",
                idPaketProgram: id,
            });
            if (id !== "") {
                const response = await akmApi.get(URL_AKM.FETCH_PENJUALAN_VOUCHER_BY_ID_PAKET + id);
                if (response) {
                    if (response.data.errorSchema.errorCode === URL_AKM.SUCCESS_ERROR_CODE) {
                        this.setState({ listPenjualanArray: response.data.data });
                        const data = { value: "", label: "Pilih Penjualan", id: "idPenjualanVoucher", selected: "selected", disabled: true };
                        this.state.listPenjualan.push(data);
                        response.data.data.map((val, i) => {
                            const data = { value: val.idPenjualanVoucher, label: val.nomorTransaksi, id: "idPenjualanVoucher" };
                            this.state.listPenjualan.push(data);
                        });
                    }
                }
            }
        }

        if (name === "idPenjualanVoucher") {
            // this.state.listPenjualanArray.map((val, i)=>{
            //     if(val.idPenjualanVoucher === id){
            //         const jumlah = val.jumlahVoucher;
            //         const terpakai = val.jumlahTerpakai === null ? 0 : val.jumlahTerpakai;
            //         this.setState({
            //             penjualanObj: val,
            //             'sisaVoucher': jumlah-terpakai
            //         });
            //     }
            // })
            this.setState({ idPenjualanVoucher: id });
            const response = await akmApi.get(URL_AKM.FETCH_VOUCHER_BY_ID_PENJUALAN + id);
            if (response) {
                if (response.data.errorSchema.errorCode === URL_AKM.SUCCESS_ERROR_CODE) {
                    console.log(response.data.data);
                    console.log("====================================");
                    this.setState({
                        objectSekolah: {},
                        listVoucher: response.data.data.listVoucher,
                        sisaVoucher: response.data.data.voucherAvailable,
                        voucherTerpakai: response.data.data.voucherNotAvailable,
                    });
                }
            }
            if (id === "") {
                this.setState({ sisaVoucher: "", voucherTerpakai: "" });
            }
        }

        // if (name === "idSekolah") {
        //     let data = new FormData();
        //     data.append("idSekolah", id);
        //     data.append("idPenjualanVoucher", this.state.idPenjualanVoucher);

        //     const response = await akmApi.post(URL_AKM.FETCH_VOUCHER_BY_ID_PENJUALAN_ID_SEKOLAH, data).catch(function (error) {
        //         this.setState({ error });
        //     });

        //     if (response) {
        //         if (response.data.errorSchema.errorCode === URL_AKM.SUCCESS_ERROR_CODE) {
        //             this.setState({
        //                 objectSekolah: {},
        //                 jumVoucherSekolah: response.data.data.jumVoucher,
        //                 listVoucherSekolah: response.data.data.listVoucher,
        //             });

        //             // reload sisa voucher
        //             const responseReload = await akmApi.get(URL_AKM.FETCH_VOUCHER_BY_ID_PENJUALAN + this.state.idPenjualanVoucher);
        //             if (responseReload) {
        //                 if (responseReload.data.errorSchema.errorCode === URL_AKM.SUCCESS_ERROR_CODE) {
        //                     this.setState({
        //                         listVoucher: responseReload.data.data.listVoucher,
        //                         sisaVoucher: responseReload.data.data.voucherAvailable,
        //                         voucherTerpakai: responseReload.data.data.voucherNotAvailable,
        //                     });
        //                 }
        //             }
        //         }
        //     }

        //     this.state.listSekolahArray.map((val, i) => {
        //         if (val.idSekolah === id) {
        //             this.setState({ objectSekolah: val });
        //         }
        //     });

        //     if (id === "") {
        //         this.setState({ objectSekolah: {} });
        //     }
        // }

        if (name === "idSekolah") {
            const response = await akmApi.get(URL_AKM.FETCH_STUDENT_BY_SCHOOL + id).catch(function (error) {
                this.setState({ error });
            });

            this.setState({ idSekolah: id });
            if (response.data.data) {
                if (response.data.errorSchema.errorCode === URL_AKM.SUCCESS_ERROR_CODE) {
                    this.setState({ searchBySchool: response.data.data });
                }
            }

            // console.log("====================================");
            // console.log("by school", this.state.searchBySchool);
            // console.log("====================================");
        }

        if (name === "typeActivation") {
            console.log("====================================");
            console.log("tipe aktivasi");
            console.log("====================================");
        }

        this.setState({ isFetching: false });
    };

    handleOnChange = async (e) => {
        this.setState({ [e.target.id]: e.target.value });
    };

    handleChange = async (e) => {
        this.setState({ setUsername: e.target.value });
    };

    handleCariUsername = async (e) => {
        const response = await akmApi.get(URL_AKM.FETCH_STUDENT_BY_USERNAME + this.state.setUsername).catch(function (error) {
            this.setState({ error });
        });

        if (response.data.data) {
            if (response.data.errorSchema.errorCode === URL_AKM.SUCCESS_ERROR_CODE) {
                this.setState({ searchUsername: response.data.data });
                this.setState({ idSekolah: response.data.data.idSekolah });
            }
        }

        response.data.data.kelas.map((item, i) => {
            item.kelasParalel.map((kp, i) => {
                kp.siswa.map((val, i) => {
                    this.renderCheckboxSiswa(val.idSiswa);
                });
            });
        });
    };

    handleAktivasi = async (e) => {
        this.setState({ isFetching: true });

        // console.log("====================================");
        // console.log("id paket program", this.state.idPaketProgram);
        // console.log("id penjualan", this.state.idPenjualanVoucher);
        // console.log("data checkbox", this.state.dataCheckboxSiswa);
        // console.log("====================================");

        let data = {
            idSekolah: this.state.idSekolah,
            idPaketProgram: this.state.idPaketProgram,
            idPenjualanVoucher: this.state.idPenjualanVoucher,
            kodeJenisVoucher: "EVENT",
            usernameSiswa: null,
            idSiswa: this.state.dataCheckboxSiswa,
        };

        const response = await akmApi.post(URL_AKM.ACTIVATE_VOUCHER, data).catch(function (error) {
            this.setState({ error });
        });

        if (response.data.data) {
            if (response.data.errorSchema.errorCode === URL_AKM.SUCCESS_ERROR_CODE) {
                this.setState({
                    isFetching: false,
                    alertShow: true,
                    keterangan: response.data.errorSchema.errorMessage,
                    idSekolah: null,
                    idPaketProgram: null,
                    idPenjualanVoucher: null,
                    dataCheckboxSiswa: [],
                    dataCheckboxKelasPararel: [],
                    dataCheckboxKelas: [],
                });

                setTimeout(() => {
                    window.location.reload(true);
                }, 2000);
            } else {
                this.setState({
                    isFetching: false,
                    alertShow: true,
                    keterangan: response.data.errorSchema.errorMessage,
                });
            }
        }

        console.log("====================================");
        console.log(response);
        console.log("====================================");
    };

    componentDidUpdate() {
        // console.clear();
        // console.log("====================================");
        // console.log("data checkbox kelas", this.state.dataCheckboxKelas);
        // console.log("data checkbox pararel", this.state.dataCheckboxKelasPararel);
        // console.log("data checkbox siswa", this.state.dataCheckboxSiswa);
        // console.log("====================================");
    }

    // simpanJumlahVoucher = async (e) => {
    //     this.setState({ isFetching: true });
    //     let data = new FormData();
    //     data.append("idSekolah", this.state.idSekolah);
    //     data.append("idPenjualanVoucher", this.state.idPenjualanVoucher);
    //     data.append("jumlahVoucher", this.state.jumNewVoucherSekolah);

    //     console.log(data);
    //     const response = await akmApi.post(URL_AKM.SIMPAN_VOUCHER_SEKOLAH, data).catch(function (error) {
    //         this.setState({ error });
    //     });

    //     if (response) {
    //         if (response.data.errorSchema.errorCode === URL_AKM.SUCCESS_ERROR_CODE) {
    //             this.setState({
    //                 objectSekolah: {},
    //                 jumVoucherSekolah: response.data.data.jumVoucher,
    //                 listVoucherSekolah: response.data.data.listVoucher,
    //                 jumNewVoucherSekolah: "0",
    //                 keterangan: response.data.data.message,
    //             });

    //             // reload sisa voucher
    //             const responseReload = await akmApi.get(URL_AKM.FETCH_VOUCHER_BY_ID_PENJUALAN + this.state.idPenjualanVoucher);
    //             if (responseReload) {
    //                 if (responseReload.data.data === null) {
    //                     this.setState({
    //                         listVoucher: [],
    //                         sisaVoucher: "",
    //                         voucherTerpakai: "",
    //                     });
    //                 } else if (responseReload.data.errorSchema.errorCode === URL_AKM.SUCCESS_ERROR_CODE) {
    //                     this.setState({
    //                         listVoucher: responseReload.data.data.listVoucher,
    //                         sisaVoucher: responseReload.data.data.voucherAvailable,
    //                         voucherTerpakai: responseReload.data.data.voucherNotAvailable,
    //                     });
    //                 }

    //                 data = new FormData();
    //                 data.append("idSekolah", this.state.idSekolah);
    //                 data.append("idPenjualanVoucher", this.state.idPenjualanVoucher);

    //                 const response = await akmApi.post(URL_AKM.FETCH_VOUCHER_BY_ID_PENJUALAN_ID_SEKOLAH, data).catch(function (error) {
    //                     this.setState({ error });
    //                 });

    //                 if (response) {
    //                     if (response.data.errorSchema.errorCode === URL_AKM.SUCCESS_ERROR_CODE) {
    //                         this.setState({
    //                             objectSekolah: {},
    //                             jumVoucherSekolah: response.data.data.jumVoucher,
    //                             listVoucherSekolah: response.data.data.listVoucher,
    //                         });
    //                     }
    //                 }

    //                 this.state.listSekolahArray.map((val, i) => {
    //                     if (val.idSekolah === this.state.idSekolah) {
    //                         this.setState({ objectSekolah: val });
    //                     }
    //                 });
    //             }
    //         }
    //     }
    //     this.setState({ isFetching: false, alertShow: true });
    // };

    handleChangeCheckboxKelas = async (e) => {
        let isChecked = e.target.checked;
        let value = parseInt(e.target.value);

        console.log(value);

        if (isChecked) {
            // this.state.searchBySchool.kelas.map((sekolah, i) => {
            //   if (sekolah.idKelas === value) {
            //     this.setState({ dataCheckboxKelasPararel: this.state.dataCheckboxKelasPararel.filter((itemkl) => !sekolah.kelasParalel.some(({ idKelasPararel }) => itemkl === idKelasPararel)) });
            //     this.setState({ isChecked: true });
            //     this.setState((prevState) => ({
            //       dataCheckboxKelas: [...prevState.dataCheckboxKelas, value],
            //     }));
            //     sekolah.kelasParalel.map((kelas, i) => {
            //       this.setState({ dataCheckboxSiswa: this.state.dataCheckboxSiswa.filter((itemss) => !kelas.siswa.some(({ idSiswa }) => itemss === idSiswa)) });
            //       this.setState({ isChecked: true });
            //       this.setState((prevState) => ({
            //         dataCheckboxKelasPararel: [...prevState.dataCheckboxKelasPararel, kelas.idKelasPararel],
            //       }));
            //       kelas.siswa.map((siswa, i) => {
            //         console.info("siswa", siswa.namaSiswa);
            //         this.setState({ isChecked: true });
            //         this.setState((prevState) => ({
            //           dataCheckboxSiswa: [...prevState.dataCheckboxSiswa, siswa.idSiswa],
            //         }));
            //       });
            //     });
            //   }
            // });

            var arraySiswa = [...this.state.dataCheckboxSiswa];
            console.log("arayBefore", arraySiswa);

            this.state.searchBySchool.kelas.map((sekolah, i) => {
                // kelas
                if (sekolah.idKelas === value) {
                    this.setState((prevState) => ({
                        dataCheckboxKelas: [...prevState.dataCheckboxKelas, value],
                    }));
                    // kelas paralel
                    sekolah.kelasParalel.map((kelasParalel, i) => {
                        this.setState((prevState) => ({
                            dataCheckboxKelasPararel: [...prevState.dataCheckboxKelasPararel, kelasParalel.idKelasPararel],
                        }));
                        // siswa
                        kelasParalel.siswa.map((siswa, i) => {
                            const idSiswa = siswa.idSiswa;
                            arraySiswa.push(idSiswa);
                        }); // end siswa
                    }); //end kelas paralel
                } // end kelas
            });

            var finalArraySiswa = [];

            arraySiswa.map((item, i) => {
                if (!finalArraySiswa.some((idSiswa) => idSiswa === item)) {
                    finalArraySiswa.push(item);
                }
            });

            this.setState({ dataCheckboxSiswa: finalArraySiswa });
        } else {
            // this.state.searchBySchool.kelas.map((sekolah, i) => {
            //   if (sekolah.idKelas === value) {
            //     this.setState({ isChecked: false });
            //     this.setState({ dataCheckboxKelas: this.state.dataCheckboxKelas.filter((itemkp) => itemkp !== value) });
            //     this.setState({ dataCheckboxKelasPararel: this.state.dataCheckboxKelasPararel.filter((itemkl) => !sekolah.kelasParalel.some(({ idKelasPararel }) => itemkl === idKelasPararel)) });
            //     sekolah.kelasParalel.map((kelas, i) => {
            //       this.setState({ dataCheckboxSiswa: this.state.dataCheckboxSiswa.filter((itemss) => !kelas.siswa.some(({ idSiswa }) => itemss === idSiswa)) });
            //     });
            //   }
            // });

            var arraySiswa = [...this.state.dataCheckboxSiswa];

            this.state.searchBySchool.kelas.map((sekolah, i) => {
                // remove  kelas
                if (sekolah.idKelas === value) {
                    var arrayKelas = [...this.state.dataCheckboxKelas];
                    var indexKelas = arrayKelas.indexOf(sekolah.idKelas);
                    this.setState({ dataCheckboxKelas: this.state.dataCheckboxKelas.filter((itemkp) => itemkp !== value) });
                    this.setState({ dataCheckboxKelasPararel: this.state.dataCheckboxKelasPararel.filter((itemkl) => !sekolah.kelasParalel.some(({ idKelasPararel }) => itemkl === idKelasPararel)) });
                    // kelas paralel
                    sekolah.kelasParalel.map((kelasParalel, i) => {
                        // remove siswa
                        kelasParalel.siswa.map((siswa, i) => {
                            var indexSiswa = arraySiswa.indexOf(siswa.idSiswa);
                            if (indexSiswa !== -1) {
                                arraySiswa.splice(indexSiswa, 1);
                            }
                        }); // end remove  siswa
                        this.setState({ dataCheckboxSiswa: arraySiswa });
                        console.log("last", arraySiswa);
                    }); //end remove  kelas paralel
                } // end remove  kelas
            });
        }
    };

    handleChangeCheckboxKelasPararel = async (e) => {
        let isChecked = e.target.checked;
        let value = parseInt(e.target.value);

        if (isChecked) {
            this.state.searchBySchool.kelas.map((sekolah, i) => {
                sekolah.kelasParalel.map((kelas, i) => {
                    if (kelas.idKelasPararel === value) {
                        this.setState({ dataCheckboxSiswa: this.state.dataCheckboxSiswa.filter((item) => !kelas.siswa.some(({ idSiswa }) => item === idSiswa)) });
                        this.setState({ isChecked: true });
                        this.setState((prevState) => ({
                            dataCheckboxKelasPararel: [...prevState.dataCheckboxKelasPararel, value],
                        }));
                        kelas.siswa.map((siswa, i) => {
                            this.setState({ isChecked: true });
                            this.setState((prevState) => ({
                                dataCheckboxSiswa: [...prevState.dataCheckboxSiswa, siswa.idSiswa],
                            }));
                        });
                    }
                });
            });
        } else {
            this.state.searchBySchool.kelas.map((sekolah, i) => {
                sekolah.kelasParalel.map((kelas, i) => {
                    if (kelas.idKelasPararel === value) {
                        this.setState({ isChecked: false });
                        this.setState({ dataCheckboxKelasPararel: this.state.dataCheckboxKelasPararel.filter((item) => item !== value) });
                        this.setState({ dataCheckboxSiswa: this.state.dataCheckboxSiswa.filter((item) => !kelas.siswa.some(({ idSiswa }) => item === idSiswa)) });
                        // kelas.siswa.map((siswa, i) => {
                        //     this.setState({ isChecked: false });
                        // });
                    }
                });
            });
        }
    };

    handleChangeCheckboxSiswa = async (e) => {
        let checked = e.target.checked;
        let value = parseInt(e.target.value);

        if (checked) {
            this.setState({ isChecked: true });
            this.setState((prevState) => ({
                dataCheckboxSiswa: [...prevState.dataCheckboxSiswa, value],
            }));
        } else {
            // this.setState({ isChecked: false });
            // this.setState({ dataCheckboxSiswa: this.state.dataCheckboxSiswa.filter((item) => item !== value) });
            var arraySiswa = [...this.state.dataCheckboxSiswa]; // make a separate copy of the array
            var indexSiswa = arraySiswa.indexOf(value);
            if (indexSiswa !== -1) {
                arraySiswa.splice(indexSiswa, 1);
                this.setState({ dataCheckboxSiswa: arraySiswa });
            }
        }
    };

    renderCheckboxKelas = (idKelas) => {
        let checkbox = <Checkbox checked={false} value={idKelas} onChange={this.handleChangeCheckboxKelas} color="primary" inputProps={{ "aria-label": "controlled" }} />;

        this.state.dataCheckboxKelas.map((item) => {
            if (item === idKelas) {
                checkbox = <Checkbox checked value={idKelas} onChange={this.handleChangeCheckboxKelas} color="primary" inputProps={{ "aria-label": "controlled" }} />;
            }
        });

        return checkbox;
    };

    renderCheckboxKelasPararel = (idKelasPararel) => {
        let checkbox = <Checkbox checked={false} value={idKelasPararel} onChange={this.handleChangeCheckboxKelasPararel} color="primary" inputProps={{ "aria-label": "controlled" }} />;

        this.state.dataCheckboxKelasPararel.map((item) => {
            if (item === idKelasPararel) {
                checkbox = <Checkbox checked value={idKelasPararel} onChange={this.handleChangeCheckboxKelasPararel} color="primary" inputProps={{ "aria-label": "controlled" }} />;
            }
        });

        return checkbox;
    };

    renderCheckboxSiswa = (idSiswa) => {
        let checkbox = <Checkbox checked={false} value={idSiswa} onChange={this.handleChangeCheckboxSiswa} color="primary" inputProps={{ "aria-label": "controlled" }} />;

        this.state.dataCheckboxSiswa.map((item) => {
            if (item === idSiswa) {
                checkbox = <Checkbox checked={true} value={idSiswa} onChange={this.handleChangeCheckboxSiswa} color="primary" inputProps={{ "aria-label": "controlled" }} />;
            }
        });

        return checkbox;
    };

    render() {
        const ExcelFile = ReactExport.ExcelFile;
        const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
        const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;

        const {
            error,
            isFetching,
            listProvinsi,
            listKabKota,
            idProvinsi,
            idKabKota,
            idSekolah,
            idPaketProgram,
            idPenjualanVoucher,
            sisaVoucher,
            voucherTerpakai,
            objectSekolah,
            jumVoucherSekolah,
            jumNewVoucherSekolah,
            kodeJenjangSekolah,
            listSekolah,
            listPaketProgram,
            listPenjualan,
            listVoucherSekolah,
            searchBySchool,
            searchUsername,
            isChecked,
            kodeJenisVoucher,
        } = this.state;

        const listKodeJenjang = [
            { value: "SD", label: "SD", id: "kodeJenjangSekolah" },
            { value: "SMP", label: "SMP", id: "kodeJenjangSekolah" },
            { value: "SMA", label: "SMA", id: "kodeJenjangSekolah" },
            { value: "SMK", label: "SMK", id: "kodeJenjangSekolah" },
            { value: "MI", label: "MI", id: "kodeJenjangSekolah" },
            { value: "MTs", label: "MTs", id: "kodeJenjangSekolah" },
            { value: "MA", label: "MA", id: "kodeJenjangSekolah" },
        ];

        const listTipe = [
            { value: "PREMIUM", label: "PREMIUM", id: "typeActivation", disabled: true },
            { value: "PSEP", label: "PSEP", id: "typeActivation", disabled: true },
            { value: "EVENT", label: "EVENT", id: "typeActivation" },
        ];

        if (error) {
            return <div>Error: {error.message}</div>;
        }

        return (
            <div className="wrapper">
                <LoaderModal isFetching={isFetching} />
                <Sidebar account={this.props.account} />
                <div id="content" style={{ paddingBottom: "50px" }}>
                    <Navbar />
                    <Row>
                        <Col>
                            <h3>MGT VOUCHER</h3>
                        </Col>
                    </Row>
                    {this.loadAlert()}
                    <Row>
                        <Col sm={4}>
                            Tipe Aktivasi
                            <Fragment>
                                <Select options={listTipe} onChange={this.handleChangeSelect} placeholder="Pilih Tipe Aktivasi..." defaultValue={listTipe[2]} isOptionDisabled={(option) => option.disabled} />
                                <input tabIndex={-1} autoComplete="off" style={{ opacity: 0, height: 0 }} value={kodeJenisVoucher} required />
                            </Fragment>
                        </Col>
                        <Col sm={8}>
                            Pilih Program yang sedang berlangsung :
                            <Fragment>
                                <Select options={listPaketProgram} onChange={this.handleChangeSelect} placeholder="Pilih Program..." />
                                <input tabIndex={-1} autoComplete="off" style={{ opacity: 0, height: 0 }} value={idPaketProgram} required />
                            </Fragment>
                        </Col>
                    </Row>
                    <Row>
                        <Col sm={4}>
                            No. Transaksi
                            <Fragment>
                                <Select options={listPenjualan} onChange={this.handleChangeSelect} placeholder="Pilih Tipe Aktivasi..." />
                                <input tabIndex={-1} autoComplete="off" style={{ opacity: 0, height: 0 }} value={idPenjualanVoucher} required />
                            </Fragment>
                        </Col>
                        <Col sm={4}>
                            Stok Tersedia
                            <div style={{ paddingTop: 8, paddingLeft: 10, backgroundColor: "#e3e3e3", height: "43%", borderRadius: 4, color: "#888888", display: "block" }}>{sisaVoucher}</div>
                        </Col>
                        <Col sm={4}>
                            Stok Teraktivasi
                            <div style={{ paddingTop: 8, paddingLeft: 10, backgroundColor: "#e3e3e3", height: "43%", borderRadius: 4, color: "#888888", display: "block" }}>{voucherTerpakai}</div>
                        </Col>
                    </Row>
                    <Tabs defaultActiveKey="sekolah" id="controlled-tab-example" className="mb-3">
                        <Tab eventKey="sekolah" title="Aktivasi By Sekolah">
                            <Row>
                                <Col sm={4}>
                                    Provinsi
                                    <Fragment>
                                        <Select options={listProvinsi} onChange={this.handleChangeSelect} placeholder="Pilih Provinsi..." />
                                        <input tabIndex={-1} autoComplete="off" style={{ opacity: 0, height: 0 }} value={idProvinsi} required />
                                    </Fragment>
                                </Col>
                                <Col sm={4}>
                                    Kota/Kabupaten
                                    <Fragment>
                                        <Select options={listKabKota} onChange={this.handleChangeSelect} placeholder="Pilih Kabupaten / Kota..." />
                                        <input tabIndex={-1} autoComplete="off" style={{ opacity: 0, height: 0 }} value={idKabKota} required />
                                    </Fragment>
                                </Col>
                                <Col sm={4}>
                                    Sekolah
                                    <Fragment>
                                        <Select options={listSekolah} onChange={this.handleChangeSelect} placeholder="Pilih sekolah..." />
                                        <input tabIndex={-1} autoComplete="off" style={{ opacity: 0, height: 0 }} value={idSekolah} required />
                                    </Fragment>
                                </Col>
                            </Row>
                        </Tab>
                        <Tab eventKey="username" title="Aktivasi By Username">
                            <Row>
                                <Col sm={2}></Col>
                                <Col sm={6}>
                                    Username
                                    <Fragment>
                                        <TextField placeholder="Cari Username" variant="outlined" size="small" fullWidth onChange={this.handleChange} />
                                    </Fragment>
                                </Col>
                                <Col sm={4}>
                                    <Button variant="primary" color="primary" onClick={this.handleCariUsername} style={{ marginTop: 25 }}>
                                        Cari
                                    </Button>
                                </Col>
                            </Row>
                        </Tab>
                    </Tabs>

                    <Row>
                        <Col sm={12} style={{ textAlign: "center" }}>
                            <Button variant="outline-primary" color="primary" onClick={this.handleAktivasi} style={{ marginTop: 25 }}>
                                Aktivasi Voucher
                            </Button>
                        </Col>
                    </Row>

                    <Row style={{ marginTop: 30 }}>
                        <Col sm={12}>
                            <Card>
                                <Card.Body>
                                    <Row>
                                        {!__.isEmpty(searchBySchool) && (
                                            <Col sm={6}>
                                                <Card>
                                                    <div style={{ marginBottom: 10 }}>
                                                        <div style={{ textAlign: "center" }}>{searchBySchool.namaSekolah}</div>
                                                        <div style={{ textAlign: "right", marginRight: 10, color: "lightgrey", cursor: "pointer", marginTop: -25 }} onClick={this.handleCariUsername}>
                                                            x
                                                        </div>
                                                    </div>
                                                    <div>
                                                        {searchBySchool.kelas.map((sekolah, i) => (
                                                            <ul style={{ listStyleType: "none", margin: 0, padding: 0 }}>
                                                                <li>
                                                                    <Accordion style={{ boxShadow: "none", borderBottom: "1px solid" }}>
                                                                        <AccordionSummary style={{ border: 0, width: "100%" }}>
                                                                            {this.renderCheckboxKelas(sekolah.idKelas)}
                                                                            <span style={{ paddingTop: 10 }}>{sekolah.namaKelas}</span>
                                                                        </AccordionSummary>
                                                                        <AccordionDetails>
                                                                            <ul style={{ listStyleType: "none" }}>
                                                                                {sekolah.kelasParalel.map((kelas, i) => (
                                                                                    <li>
                                                                                        <Accordion style={{ boxShadow: "none", borderBottom: "1px solid" }}>
                                                                                            <AccordionSummary style={{ border: 0, width: "100%" }}>
                                                                                                {this.renderCheckboxKelasPararel(kelas.idKelasPararel)}
                                                                                                <span style={{ paddingTop: 10 }}>{kelas.namaKelasParalel}</span>
                                                                                            </AccordionSummary>
                                                                                            <AccordionDetails>
                                                                                                <ul style={{ listStyleType: "none" }}>
                                                                                                    {kelas.siswa.map((siswa, i) => (
                                                                                                        <li>
                                                                                                            {this.renderCheckboxSiswa(siswa.idSiswa)}
                                                                                                            <span style={{ paddingTop: 10 }}>
                                                                                                                {siswa.namaSiswa} || {siswa.usernameSiswa}
                                                                                                            </span>
                                                                                                        </li>
                                                                                                    ))}
                                                                                                </ul>
                                                                                            </AccordionDetails>
                                                                                        </Accordion>
                                                                                    </li>
                                                                                ))}
                                                                            </ul>
                                                                        </AccordionDetails>
                                                                    </Accordion>
                                                                </li>
                                                            </ul>
                                                        ))}
                                                    </div>
                                                </Card>
                                            </Col>
                                        )}

                                        {!__.isEmpty(searchUsername) && (
                                            <Col sm={6}>
                                                <Card>
                                                    <div style={{ marginBottom: 10 }}>
                                                        <div style={{ textAlign: "center" }}>{searchUsername.namaSekolah}</div>
                                                        <div style={{ textAlign: "right", marginRight: 10, color: "lightgrey", cursor: "pointer", marginTop: -25 }} onClick={this.handleCariUsername}>
                                                            x
                                                        </div>
                                                    </div>
                                                    <div style={{ padding: 15 }}>
                                                        {searchUsername.kelas.map((kelas, i) => (
                                                            <div>
                                                                {kelas.kelasParalel.map((kelasParalel, i) => (
                                                                    <div>
                                                                        {kelasParalel.siswa.map((siswa, i) => (
                                                                            <Row>
                                                                                <Col sm={1}>{this.renderCheckboxSiswa(siswa.idSiswa)}</Col>
                                                                                <Col sm={11}>
                                                                                    <table width="100%" className="table table-striped">
                                                                                        <tr>
                                                                                            <td width="30%">Kelas Paralel</td>
                                                                                            <td width="3%">:</td>
                                                                                            <td>{kelasParalel.namaKelasParalel}</td>
                                                                                        </tr>
                                                                                        <tr>
                                                                                            <td>Nama Siswa</td>
                                                                                            <td>:</td>
                                                                                            <td>{siswa.namaSiswa}</td>
                                                                                        </tr>
                                                                                        <tr>
                                                                                            <td>Username</td>
                                                                                            <td>:</td>
                                                                                            <td>{siswa.usernameSiswa}</td>
                                                                                        </tr>
                                                                                    </table>
                                                                                </Col>
                                                                            </Row>
                                                                        ))}
                                                                    </div>
                                                                ))}
                                                            </div>
                                                        ))}
                                                    </div>
                                                </Card>
                                            </Col>
                                        )}
                                    </Row>
                                </Card.Body>
                            </Card>
                        </Col>
                    </Row>

                    {/* {!__.isEmpty(objectSekolah) && (
                        <Row>
                            <Col>
                                <table width="100%">
                                    <thead>
                                        <tr>
                                            <th>Nama Sekolah</th>
                                            <th style={{ "text-align-last": "center" }}>Booked</th>
                                            <th style={{ "text-align-last": "center" }}></th>
                                            <th style={{ "text-align-last": "center" }}>Jumlah new Voucher</th>
                                            <th style={{ "text-align-last": "center" }}>Aksi</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td width="40%">{objectSekolah.namaSekolah}</td>
                                            <td width="20%" style={{ "text-align-last": "center" }}>
                                                <input className="form-control" type="number" value={jumVoucherSekolah} />
                                            </td>
                                            <td width="5%" style={{ "text-align-last": "center" }}></td>
                                            <td width="20%" style={{ "text-align-last": "center" }}>
                                                <input className="form-control" type="number" id="jumNewVoucherSekolah" name="jumNewVoucherSekolah" value={jumNewVoucherSekolah} onChange={this.handleOnChange} />
                                            </td>
                                            <td width="15%" style={{ "text-align-last": "center" }}>
                                                <button className="btn btn-outline-primary" title="Simpan Voucher" onClick={() => this.simpanJumlahVoucher()}>
                                                    <li className="fa fa-save"></li>
                                                </button>
                                                &nbsp;
                                                {jumVoucherSekolah > 0 && (
                                                    <ExcelFile
                                                        element={
                                                            <button className="btn btn-outline-danger" title="Download Voucher">
                                                                <li className="fa fa-download"></li>
                                                            </button>
                                                        }
                                                        filename="Voucher Siswa"
                                                    >
                                                        <ExcelSheet data={listVoucherSekolah} name="Voucher Siswa">
                                                            <ExcelColumn label="Kode Voucher" value="kodeVoucher" />
                                                            <ExcelColumn label="Status Voucher" value="statusVoucher" />
                                                        </ExcelSheet>
                                                    </ExcelFile>
                                                )}
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </Col>
                        </Row>
                    )} */}
                </div>
            </div>
        );
    }

    loadAlert = () => {
        const { alertShow, keterangan } = this.state;

        if (alertShow) {
            return (
                <Alert variant="info" onClose={() => this.setState({ alertShow: false })} dismissible>
                    <strong>{keterangan}</strong>
                </Alert>
            );
        }
    };
}

const mapStateToProps = (state) => {
    return {
        account: state.account,
    };
};

export default connect(mapStateToProps, { cekCookies })(Voucher);
